angular.module("avant.customer_applications.directives").directive 'capitalize', ->
  restrict: 'A'
  require: '?ngModel'
  link: (scope, element, attrs, ctrl) ->

    toUpperCase = (input) ->
      input?.toUpperCase()

    ctrl.$parsers.unshift (input) ->
      cursorPos = element[0].selectionStart
      if input
        capitalized = toUpperCase input
        if capitalized != input
          ctrl.$setViewValue capitalized
          ctrl.$render()
          element[0].setSelectionRange cursorPos, cursorPos
        capitalized

    toUpperCase scope[attrs.ngModel]
